import React, { forwardRef, useImperativeHandle, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { FaChevronUp, FaFilePdf } from "react-icons/fa";
import Loader from '../../../components/Loader/Loader';
import { Row, Col } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import SelectFild from '../../../components/SelectFild/SelectFild';
import TimeFild from '../../../components/DateTimePicker/TimeFild';
import UploadWithSignature from '../../../components/UploadWithSignature/UploadWithSignature';


import { postIncidentDepartmentAactionTaken, getPassengerImpactMainMaster, getPassengerImpactSubMaster } from '../../../apiservices/ApiServices';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/en';


const ActionTakenByDepartment = forwardRef(({ data, details, department, postUpdateData, aircraftTypes, aircraftRegistration, toast }, ref) => {

    const [isLoadings, setLoadings] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [key, setKey] = useState(data?.departmentname);
    const [passengerImpactM, setPassengerImpactM] = useState([]);
    const [passengerImpactS, setPassengerImpactS] = useState([]);
    const [selectedPassengerImp, setSelectedPassengerImp] = useState([]);
    const [localTime, setLocalTime] = useState(dayjs().format('HH:mm'));
    const [notifyTo, setNotifyTo] = useState([]);

    const [hsseImgs, setHsseImgs] = useState([]);
    const [aoccImgs, setAoccImgs] = useState([]);
    const [airsideImgs, setAirsideImgs] = useState([]);
    const [terinalImgs, setTerinalImgs] = useState([]);
    const [engineeringImgs, setEngineeringImgs] = useState([]);
    const [fireImgs, setFireImgs] = useState([]);
    const [otherImgs, setOtherImgs] = useState([]);
    const [AirlineImgs, setAirlineImgs] = useState([]);

    const navigate = useNavigate();

    const getPassengerImpactMainMasters = async () => {
        try {
            const res = await getPassengerImpactMainMaster();
            setPassengerImpactM(res.data.data);
        } catch (error) {
        }
    };

    const getPassengerImpactSubMasters = async () => {
        try {
            const res = await getPassengerImpactSubMaster();
            setPassengerImpactS(res.data.data);
        } catch (error) {

        }
    };

    useEffect(() => {
        setKey(data?.departmentname);
    }, [data]);

    useEffect(() => {
        getPassengerImpactMainMasters();
        getPassengerImpactSubMasters();
    }, []);

    useEffect(() => {
        if (details?.notify_to && details?.notify_to.length > 0) {
            const ndata = JSON.parse(details?.notify_to);
            setNotifyTo(ndata);
        }
    }, [details]);


    const initialValues = {
        //department (AOCC)
        AOCC_id: '',
        AOCC_status: 1,
        AOCC_statusName: 'Draft',
        AOCC_isNa: 0,
        dPersonName: '',
        dActionTime: localTime,
        dActionTaken: '',
        dCommunicationLog: '',
        AOCC_recommendationhod: '',
        AOCC_remarks: '',

        //department (HSSE)
        HSSE_id: '',
        HSSE_status: 1,
        HSSE_statusName: 'Draft',
        HSSE_isNa: 0,
        hPersonName: '',
        approvalTime: localTime,
        initialAssessment: '',
        recommendations: '',
        closureApproval: '',

        //department (AIRSIDE)
        AIRSIDE_id: '',
        AIRSIDE_status: 1,
        AIRSIDE_statusName: 'Draft',
        AIRSIDE_isNa: 0,
        leadOfficer: '',
        actionTime: localTime,
        actionTaken: '',
        AIRSIDE_recommendationhod: '',
        AIRSIDE_remarks: '',

        //department (FIRE)
        FIRE_id: '',
        FIRE_status: 1,
        FIRE_statusName: 'Draft',
        FIRE_isNa: 0,
        fireCommanderName: '',
        fireCategoryIncidentCode: '',
        unitDispatched: '',
        unitArrivalTime: localTime,
        fActionTaken: '',
        FIRE_recommendationhod: '',
        FIRE_remarks: '',

        //department (TERMINAL)
        TERMINAL_id: '',
        TERMINAL_status: 1,
        TERMINAL_statusName: 'Draft',
        TERMINAL_isNa: 0,
        terminalSupervisoronDuty: '',
        terminalEvacuationRequired: 'no',
        tActionTime: localTime,
        passengerImpactAs: '',
        passengerImpactSubAs: [],
        crowdControlActions: 'yes',
        TERMINAL_recommendationhod: '',
        TERMINAL_remarks: '',

        //department (ENGINEERING)
        ENGINEERING_id: '',
        ENGINEERING_status: 1,
        ENGINEERING_statusName: 'Draft',
        ENGINEERING_isNa: 0,
        ePersonName: '',
        eActionTime: localTime,
        eOccurrenceType: '',
        eLocation: '',
        eOtherOccurrenceType: '',
        eOtherLocation: '',
        eSupervisorManagerNotified: '',
        eFollowupRequired: '',
        eActionTaken: '',
        ENGINEERING_recommendationhod: '',
        ENGINEERING_remarks: '',

        //department (OTHERS)
        OTHERS_id: '',
        OTHERS_status: 1,
        OTHERS_statusName: 'Draft',
        OTHERS_isNa: 0,

        othersPersonname: '',
        othersSpecifyDepartment: '',
        othersActionTime: localTime,
        othersOccurrenceType: '',
        othersDetails: '',
        othersLocation: '',
        othersActionTaken: '',
        OTHERS_recommendationhod: '',
        OTHERS_remarks: '',

        //department (AIRLINE)
        AIRLINE_id: '',
        AIRLINE_status: 1,
        AIRLINE_statusName: 'Draft',
        AIRLINE_isNa: 0,

        airlinePersonName: '',
        airlineCode: '',
        airlineFlightNumber: '',
        airlineAircraftType: '',
        airlineArrivalTime: localTime,
        airlineDepartureTime: localTime,
        airlineGateNumber: '',
        airlineNumberofPassengers: '',
        airlineDelayReason: '',
        AIRLINE_recommendationhod: '',
        AIRLINE_remarks: '',
    };

    const getDepartmentData = (values, department) => {
        const departmentFields = {
            HSSE: ['hPersonName', 'approvalTime', 'initialAssessment', 'recommendations', 'closureApproval'],
            AOCC: ['AOCC_recommendationhod', 'AOCC_remarks', 'dPersonName', 'dActionTime', 'dActionTaken', 'dCommunicationLog'],
            AIRSIDE: ['AIRSIDE_recommendationhod', 'AIRSIDE_remarks', 'leadOfficer', 'actionTime', 'actionTaken'],
            FIRE: ['FIRE_recommendationhod', 'FIRE_remarks', 'fireCommanderName', 'fireCategoryIncidentCode', 'unitDispatched', 'unitArrivalTime', 'fActionTaken'],
            TERMINAL: ['TERMINAL_recommendationhod', 'TERMINAL_remarks', 'terminalSupervisoronDuty', 'terminalEvacuationRequired', 'tActionTime', 'passengerImpactAs', 'passengerImpactSubAs', 'crowdControlActions'],
            ENGINEERING: ['ENGINEERING_recommendationhod', 'ENGINEERING_remarks', 'ePersonName', 'eActionTime', 'eOccurrenceType', 'eLocation', 'eOtherOccurrenceType', 'eOtherLocation', 'eSupervisorManagerNotified', 'eFollowupRequired', 'eActionTaken'],
            OTHERS: ['OTHERS_recommendationhod', 'OTHERS_remarks', 'othersPersonname', 'othersSpecifyDepartment', 'othersActionTime', 'othersOccurrenceType', 'othersDetails', 'othersLocation', 'othersActionTaken'],
            AIRLINE: ['AIRLINE_recommendationhod', 'AIRLINE_remarks', 'airlinePersonName', 'airlineCode', 'airlineFlightNumber', 'airlineAircraftType', 'airlineArrivalTime', 'airlineDepartureTime', 'airlineGateNumber', 'airlineNumberofPassengers', 'airlineDelayReason']
        };

        return departmentFields[department].reduce((acc, field) => {
            acc[field] = values[field];
            return acc;
        }, {});
    };

    const getTitle = (Key, status, statusName) => {
        let className = 'statuss';

        if (status == 0) {
            className = 'statuss o';
        }
        if (status == 1) {
            className = 'statuss o';
        }
        else if (status == 2) {
            className = 'statuss r';
        }
        else if (status == 3) {
            className = 'statuss g';
        }

        return (
            <div className="text-center">
                <div className={Key}>{Key}</div>
                <span className={className}>{statusName}</span>
            </div>
        );
    };

    useEffect(() => {
        if (details?.action_taken_department && details.action_taken_department.length > 0) {
            const formValues = { ...initialValues };

            details.action_taken_department.forEach((dept) => {
                const departmentName = dept.department_name; // e.g., "FIRE"
                const data = dept.data_json ? JSON.parse(dept.data_json) : {};

                const passengerImpacts = data.passengerImpactSubAs || [];
                setSelectedPassengerImp(passengerImpacts);

                switch (departmentName) {
                    case "AOCC":
                        formValues.AOCC_id = dept.id || '';
                        formValues.AOCC_status = dept.status || 1;
                        formValues.AOCC_statusName = dept.status_name || 'Draft';
                        formValues.AOCC_isNa = dept.is_na;

                        formValues.dPersonName = data.dPersonName || '';
                        formValues.dActionTime = data.dActionTime || localTime;
                        formValues.dActionTaken = data.dActionTaken || '';
                        formValues.dCommunicationLog = data.dCommunicationLog || '';
                        formValues.AOCC_recommendationhod = data.AOCC_recommendationhod || '';
                        formValues.AOCC_remarks = data.AOCC_remarks || '';

                        const AOCCimgs = dept.image_json ? dept.image_json : {};
                        setAoccImgs(AOCCimgs);
                        break;

                    case "HSSE":
                        formValues.HSSE_id = dept.id || '';
                        formValues.HSSE_status = dept.status || 1;
                        formValues.HSSE_statusName = dept.status_name || 'Draft';

                        formValues.hPersonName = data.hPersonName || '';
                        formValues.approvalTime = data.approvalTime || localTime;
                        formValues.initialAssessment = data.initialAssessment || '';
                        formValues.recommendations = data.recommendations || '';
                        formValues.closureApproval = data.closureApproval || '';

                        const HSSEimgs = dept.image_json ? dept.image_json : {};
                        setHsseImgs(HSSEimgs);
                        break;

                    case "AIRSIDE":
                        formValues.AIRSIDE_id = dept.id || '';
                        formValues.AIRSIDE_status = dept.status || 1;
                        formValues.AIRSIDE_statusName = dept.status_name || 'Draft';
                        formValues.AIRSIDE_isNa = dept.is_na;

                        formValues.leadOfficer = data.leadOfficer || '';
                        formValues.actionTime = data.actionTime || localTime;
                        formValues.actionTaken = data.actionTaken || '';
                        formValues.AIRSIDE_recommendationhod = data.AIRSIDE_recommendationhod || '';
                        formValues.AIRSIDE_remarks = data.AIRSIDE_remarks || '';

                        const AIRSIDEimgs = dept.image_json ? dept.image_json : {};
                        setAirsideImgs(AIRSIDEimgs);
                        break;

                    case "FIRE":
                        formValues.FIRE_id = dept.id || '';
                        formValues.FIRE_status = dept.status || 1;
                        formValues.FIRE_statusName = dept.status_name || 'Draft';
                        formValues.FIRE_isNa = dept.is_na;

                        formValues.fireCommanderName = data.fireCommanderName || '';
                        formValues.fireCategoryIncidentCode = data.fireCategoryIncidentCode || '';
                        formValues.unitDispatched = data.unitDispatched || '';
                        formValues.unitArrivalTime = data.unitArrivalTime || localTime;
                        formValues.fActionTaken = data.fActionTaken || '';
                        formValues.FIRE_recommendationhod = data.FIRE_recommendationhod || '';
                        formValues.FIRE_remarks = data.FIRE_remarks || '';

                        const FIREimgs = dept.image_json ? dept.image_json : {};
                        setFireImgs(FIREimgs);
                        break;

                    case "TERMINAL":
                        formValues.TERMINAL_id = dept.id || '';
                        formValues.TERMINAL_status = dept.status || 1;
                        formValues.TERMINAL_statusName = dept.status_name || 'Draft';
                        formValues.TERMINAL_isNa = dept.is_na;

                        formValues.terminalSupervisoronDuty = data.terminalSupervisoronDuty || '';
                        formValues.terminalEvacuationRequired = data.terminalEvacuationRequired || 'no';
                        formValues.tActionTime = data.tActionTime || localTime;
                        formValues.passengerImpactAs = data.passengerImpactAs || '';
                        formValues.passengerImpactSubAs = data.passengerImpactSubAs || [];
                        formValues.crowdControlActions = data.crowdControlActions || 'yes';
                        formValues.TERMINAL_recommendationhod = data.TERMINAL_recommendationhod || '';
                        formValues.TERMINAL_remarks = data.TERMINAL_remarks || '';

                        const TERMINALimgs = dept.image_json ? dept.image_json : {};
                        setTerinalImgs(TERMINALimgs);
                        break;

                    case "ENGINEERING":
                        formValues.ENGINEERING_id = dept.id || '';
                        formValues.ENGINEERING_status = dept.status || 1;
                        formValues.ENGINEERING_statusName = dept.status_name || 'Draft';
                        formValues.ENGINEERING_isNa = dept.is_na;

                        formValues.ePersonName = data.ePersonName || '';
                        formValues.eActionTime = data.eActionTime || localTime;
                        formValues.eOccurrenceType = data.eOccurrenceType || '';
                        formValues.eLocation = data.eLocation || '';
                        formValues.eOtherOccurrenceType = data.eOtherOccurrenceType || '';
                        formValues.eOtherLocation = data.eOtherLocation || '';
                        formValues.eSupervisorManagerNotified = data.eSupervisorManagerNotified || '';
                        formValues.eFollowupRequired = data.eFollowupRequired || '';
                        formValues.eActionTaken = data.eActionTaken || '';
                        formValues.ENGINEERING_recommendationhod = data.ENGINEERING_recommendationhod || '';
                        formValues.ENGINEERING_remarks = data.ENGINEERING_remarks || '';

                        const ENGINEERINGimgs = dept.image_json ? dept.image_json : {};
                        setEngineeringImgs(ENGINEERINGimgs);
                        break;

                    case "OTHERS":
                        formValues.OTHERS_id = dept.id || '';
                        formValues.OTHERS_status = dept.status || 1;
                        formValues.OTHERS_statusName = dept.status_name || 'Draft';
                        formValues.OTHERS_isNa = dept.is_na;

                        formValues.othersPersonname = data.othersPersonname || '';
                        formValues.othersSpecifyDepartment = data.othersSpecifyDepartment || '';
                        formValues.othersActionTime = data.othersActionTime || localTime;
                        formValues.othersOccurrenceType = data.othersOccurrenceType || '';
                        formValues.othersDetails = data.othersDetails || '';
                        formValues.othersLocation = data.othersLocation || '';
                        formValues.othersActionTaken = data.othersActionTaken || '';
                        formValues.OTHERS_recommendationhod = data.OTHERS_recommendationhod || '';
                        formValues.OTHERS_remarks = data.OTHERS_remarks || '';

                        const OTHERSimgs = dept.image_json ? dept.image_json : {};
                        setOtherImgs(OTHERSimgs);
                        break;

                    case "AIRLINE":
                        formValues.AIRLINE_id = dept.id || '';
                        formValues.AIRLINE_status = dept.status || 1;
                        formValues.AIRLINE_statusName = dept.status_name || 'Draft';
                        formValues.AIRLINE_isNa = dept.is_na;

                        formValues.airlinePersonName = data.airlinePersonName || '';
                        formValues.airlineArrivalTime = data.airlineArrivalTime || localTime;
                        formValues.airlineCode = data.airlineCode || '';
                        formValues.airlineFlightNumber = data.airlineFlightNumber || '';
                        formValues.airlineAircraftType = data.airlineAircraftType || '';
                        formValues.airlineDepartureTime = data.airlineDepartureTime || localTime;
                        formValues.airlineGateNumber = data.airlineGateNumber || '';
                        formValues.airlineNumberofPassengers = data.airlineNumberofPassengers || '';
                        formValues.airlineDelayReason = data.airlineDelayReason || '';
                        formValues.AIRLINE_recommendationhod = data.AIRLINE_recommendationhod || '';
                        formValues.AIRLINE_remarks = data.AIRLINE_remarks || '';

                        const AIRLINEimgs = dept.image_json ? dept.image_json : {};
                        setAirlineImgs(AIRLINEimgs);
                        break;

                    default:
                        break;
                }
            });
            formik.setValues(formValues);
        }
    }, [details]);

    const handlePassengerImpChange = (id, isChecked) => {
        const currentValues = values.passengerImpactSubAs || [];
        let newValues;

        if (isChecked) {
            newValues = [...currentValues, id];
        } else {
            newValues = currentValues.filter(item => item !== id);
        }

        setFieldValue('passengerImpactSubAs', newValues);
    };

    const getDepartmentIdByName = (departmentName) => {
        const departments = department.find((dept) => dept.name === departmentName);
        return departments ? departments.id : null;
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        enableReinitialize: true,
        onSubmit: async (values) => {
            setLoadings(true);

            const currentDepartment = key;
            const departmentIds = getDepartmentIdByName(currentDepartment);
            const departmentIdKey = `${currentDepartment}_id`;
            const departmentId = values[departmentIdKey];
            const departmentData = getDepartmentData(values, currentDepartment);


            const statusKey = data?.departmentname == 'HSSE' ? 3 : 2;

            const formData = new FormData();

            formData.append('department_id', departmentIds);
            formData.append('incident_header_id', details?.header_id);


            const recommendationhod = `${currentDepartment}_recommendationhod`;
            const recommendationValue = values[recommendationhod];
            formData.append('is_suggestion_from_hod', recommendationValue?.trim() ? 1 : 0);


            formData.append('id', departmentId || '');
            formData.append('status', statusKey);
            const isNaKey = `${currentDepartment}_isNa`;
            formData.append('is_na', values[isNaKey]);

            formData.append('data_fields', JSON.stringify(departmentData));


            uploadedFiles.forEach(file => {
                console.log('file.signatureData', file)

                if (file.originalFile.type === 'application/pdf') {
                    formData.append('images[]', file.originalFile);
                }

                if (file.signatureData) {
                    const blob = dataURLtoBlob(file.signatureData);
                    formData.append('images[]', blob, `signature_${file.originalFile.name}`);
                }
            });

            try {
                const res = await postIncidentDepartmentAactionTaken(formData);
                console.log('res', res.data);
                toast.success(res.data.message);
                postUpdateData();
                if (currentDepartment == 'HSSE') {
                    setTimeout(() => navigate("/home"), 3000);
                }

            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }

            console.log('formData', formData);
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;



    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    useImperativeHandle(ref, () => ({
        submitForm: () => {
            handleSubmit();
        }
    }));
    return (
        <>
            <div className="GroupList fieldset">
                <div className='toggle-button'>
                    <h2 className="listTitle">Action to be taken by Other Departments too</h2>
                    <div className='btnColaps'><FaChevronUp /></div>
                </div>
                <div className='subFilds'>
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className='first-start'><p>Who started first <span>{details.who_has_started}</span></p></div>
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                        >
                            <Tab eventKey="HSSE" title={getTitle('HSSE', values.HSSE_status, values.HSSE_statusName)}>
                                <div id="HSSE" className="department">
                                    <div className="fieldset" style={
                                        data?.departmentname === 'HSSE'
                                            ? { pointerEvents: 'all' }
                                            : { pointerEvents: 'none' }
                                    }>
                                        <h1>HSSE</h1>
                                        <div className="formsBox">
                                            <Row>
                                                <Col md={6}>
                                                    <div className="form-group">
                                                        <label>Person Name</label>
                                                        <input
                                                            type="text"
                                                            id="hPersonName"
                                                            name="hPersonName"
                                                            className="form-control"
                                                            autoComplete="off"
                                                            value={values.hPersonName}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.hPersonName && touched.hPersonName && (
                                                            <p className="errormsg">{errors.hPersonName}</p>
                                                        )}
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div className="form-group">
                                                        <label>Approval Time</label>
                                                        <TimeFild
                                                            value={values.approvalTime}
                                                            onChange={(time) => setFieldValue('approvalTime', time)}
                                                            format="local"
                                                        />
                                                        {errors.approvalTime && touched.approvalTime && (
                                                            <p className="errormsg">{errors.approvalTime}</p>
                                                        )}
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div className="form-group">
                                                        <label>Initial Assessment</label>
                                                        <textarea
                                                            id="initialAssessment"
                                                            name="initialAssessment"
                                                            className="form-control"
                                                            value={values.initialAssessment}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.initialAssessment && touched.initialAssessment && (
                                                            <p className="errormsg">{errors.initialAssessment}</p>
                                                        )}
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div className="form-group">
                                                        <label>Recommendations</label>
                                                        <textarea
                                                            id="recommendations"
                                                            name="recommendations"
                                                            className="form-control"
                                                            value={values.recommendations}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.recommendations && touched.recommendations && (
                                                            <p className="errormsg">{errors.recommendations}</p>
                                                        )}
                                                    </div>
                                                </Col>

                                                <Col md={6}>
                                                    <div className="form-group">
                                                        <label>Closure Approval</label>
                                                        <textarea
                                                            id="closureApproval"
                                                            name="closureApproval"
                                                            className="form-control"
                                                            value={values.closureApproval}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.closureApproval && touched.closureApproval && (
                                                            <p className="errormsg">{errors.closureApproval}</p>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <UploadWithSignature onFilesChange={setUploadedFiles} />
                                            {Array.isArray(hsseImgs) && (
                                                <div className='previewsimges'>
                                                    {hsseImgs.map((fileUrl, index) => {
                                                        if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                                            return (
                                                                <div key={index} className='imageboxs'>
                                                                    <div className='imgs pdfs'>
                                                                        <div>
                                                                            <div className="pdf-icon">
                                                                                <FaFilePdf size={48} color="#e74c3c" />
                                                                            </div>
                                                                            <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                        return (
                                                            <div key={index} className='imageboxs'>
                                                                <div className='imgs'>
                                                                    <img src={fileUrl} alt={`Image ${index + 1}`} />
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                                {data?.departmentname === 'HSSE' ?
                                    <div className="button-boxs grid">
                                        <button type="submit" className="btn btn-orange">Submit Final Report & Close Case</button>
                                    </div>
                                    : null}
                            </Tab>
                            <Tab eventKey="AOCC" title={getTitle('AOCC', values.AOCC_status, values.AOCC_statusName)}>
                                <div id="AOCC" className={values.AOCC_isNa === 1 ? 'department notapplys' : 'department'}>
                                    <div className="fieldset"
                                        style={
                                            data?.departmentname === 'AOCC' && values?.AOCC_status == 3
                                                ? { pointerEvents: 'none' }
                                                : data?.departmentname === 'AOCC' ||
                                                    data?.departmentname === 'HSSE'
                                                    ? { pointerEvents: 'all' }
                                                    : { pointerEvents: 'none' }
                                        }
                                    >
                                        <h1><span>AOCC</span>
                                            <div className="chekbox">
                                                <label>Not Applicable
                                                    <input
                                                        type="checkbox"
                                                        className="notapply"
                                                        checked={values.AOCC_isNa === 1}
                                                        onChange={(e) => {
                                                            setFieldValue('AOCC_isNa', e.target.checked ? 1 : 0);
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        </h1>
                                        {values.AOCC_isNa === 1 ? null :
                                            <div className='formsBox'>
                                                <Row>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Person Name</label>
                                                            <input
                                                                type='text'
                                                                id="dPersonName"
                                                                name="dPersonName"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={values.dPersonName}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.dPersonName && touched.dPersonName ? (
                                                                <p className='errormsg'>{errors.dPersonName}</p>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Action Time</label>
                                                            <TimeFild
                                                                value={values.dActionTime}
                                                                onChange={(time) => setFieldValue('dActionTime', time)}
                                                                format="local"
                                                            />
                                                            {errors.dActionTime && touched.dActionTime ? (
                                                                <p className='errormsg'>{errors.dActionTime}</p>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Action Taken</label>
                                                            <input
                                                                type='text'
                                                                id="dActionTaken"
                                                                name="dActionTaken"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={values.dActionTaken}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.dActionTaken && touched.dActionTaken ? (
                                                                <p className='errormsg'>{errors.dActionTaken}</p>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Communication Log</label>
                                                            <input
                                                                type='text'
                                                                id="dCommunicationLog"
                                                                name="dCommunicationLog"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={values.dCommunicationLog}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.dCommunicationLog && touched.dCommunicationLog ? (
                                                                <p className='errormsg'>{errors.dCommunicationLog}</p>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Recommendation By Hod</label>
                                                            <textarea
                                                                id="AOCC_recommendationhod"
                                                                name="AOCC_recommendationhod"
                                                                className="form-control"
                                                                value={values.AOCC_recommendationhod}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                readOnly={
                                                                    (data?.departmentname === 'AOCC' && data.is_hod !== 1) ||
                                                                    (data?.departmentname !== 'HSSE' && data?.departmentname !== 'AOCC')
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                    {values.AOCC_recommendationhod == '' && data?.departmentname === 'HSSE' ?
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Remarks</label>
                                                                <textarea
                                                                    id="AOCC_remarks"
                                                                    name="AOCC_remarks"
                                                                    className="form-control"
                                                                    value={values.AOCC_remarks}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </div>
                                                        </Col>
                                                        : null
                                                    }
                                                </Row>

                                                <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                {Array.isArray(aoccImgs) && (
                                                    <div className='previewsimges'>
                                                        {aoccImgs.map((fileUrl, index) => {
                                                            if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                                                return (
                                                                    <div key={index} className='imageboxs'>
                                                                        <div className='imgs pdfs'>
                                                                            <div>
                                                                                <div className="pdf-icon">
                                                                                    <FaFilePdf size={48} color="#e74c3c" />
                                                                                </div>
                                                                                <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                            return (
                                                                <div key={index} className='imageboxs'>
                                                                    <div className='imgs'>
                                                                        <img src={fileUrl} alt={`Image ${index + 1}`} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {data?.departmentname === 'AOCC' || data?.departmentname === 'HSSE' ?
                                    <div className="button-boxs grid">
                                        <button type="submit" className="btn btn-orange">Submit</button>
                                    </div>
                                    : null}
                            </Tab>
                            <Tab eventKey="AIRSIDE" title={getTitle('AIRSIDE', values.AIRSIDE_status, values.AIRSIDE_statusName)}>
                                <div id="AIRSIDE" className={values.AIRSIDE_isNa === 1 ? 'department notapplys' : 'department'}>
                                    <div className="fieldset"
                                        style={
                                            data?.departmentname === 'AOCC' || data?.departmentname === 'AIRSIDE' && values?.AIRSIDE_status == 3
                                                ? { pointerEvents: 'none' }
                                                : data?.departmentname === 'AIRSIDE' ||
                                                    data?.departmentname === 'AOCC' ||
                                                    data?.departmentname === 'HSSE'
                                                    ? { pointerEvents: 'all' }
                                                    : { pointerEvents: 'none' }
                                        }
                                    >
                                        <h1><span>AIRSIDE</span>
                                            <div className="chekbox">
                                                <label>Not Applicable
                                                    <input
                                                        type="checkbox"
                                                        className="notapply"
                                                        checked={values.AIRSIDE_isNa === 1}
                                                        onChange={(e) => {
                                                            setFieldValue('AIRSIDE_isNa', e.target.checked ? 1 : 0);
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        </h1>
                                        {values.AIRSIDE_isNa === 1 ? null :
                                            <div className="formsBox">
                                                <Row>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Lead Officer</label>
                                                            <input
                                                                type="text"
                                                                id="leadOfficer"
                                                                name="leadOfficer"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={values.leadOfficer}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.leadOfficer && touched.leadOfficer && (
                                                                <p className="errormsg">{errors.leadOfficer}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Action Time</label>
                                                            <TimeFild
                                                                value={values.actionTime}
                                                                onChange={(time) => setFieldValue('actionTime', time)}
                                                                format="local"
                                                            />
                                                            {errors.actionTime && touched.actionTime && (
                                                                <p className="errormsg">{errors.actionTime}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Action Taken</label>
                                                            <textarea
                                                                id="actionTaken"
                                                                name="actionTaken"
                                                                className="form-control"
                                                                value={values.actionTaken}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.actionTaken && touched.actionTaken && (
                                                                <p className="errormsg">{errors.actionTaken}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Recommendation By Hod</label>
                                                            <textarea
                                                                id="AIRSIDE_recommendationhod"
                                                                name="AIRSIDE_recommendationhod"
                                                                className="form-control"
                                                                value={values.AIRSIDE_recommendationhod}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                readOnly={
                                                                    (data?.departmentname === 'AIRSIDE' && data.is_hod !== 1) ||
                                                                    (data?.departmentname !== 'HSSE' && data?.departmentname !== 'AIRSIDE')
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                    {values.AIRSIDE_recommendationhod == '' && data?.departmentname === 'HSSE' ?
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Remarks</label>
                                                                <textarea
                                                                    id="AIRSIDE_remarks"
                                                                    name="AIRSIDE_remarks"
                                                                    className="form-control"
                                                                    value={values.AIRSIDE_remarks}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </div>
                                                        </Col>
                                                        : null
                                                    }
                                                </Row>
                                                <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                {Array.isArray(airsideImgs) && (
                                                    <div className='previewsimges'>
                                                        {airsideImgs.map((fileUrl, index) => {
                                                            if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                                                return (
                                                                    <div key={index} className='imageboxs'>
                                                                        <div className='imgs pdfs'>
                                                                            <div>
                                                                                <div className="pdf-icon">
                                                                                    <FaFilePdf size={48} color="#e74c3c" />
                                                                                </div>
                                                                                <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                            return (
                                                                <div key={index} className='imageboxs'>
                                                                    <div className='imgs'>
                                                                        <img src={fileUrl} alt={`Image ${index + 1}`} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {data?.departmentname === 'AIRSIDE' || data?.departmentname === 'AOCC' || data?.departmentname === 'HSSE' ?
                                    <div className="button-boxs grid">
                                        <button type="submit" className="btn btn-orange">Submit</button>
                                    </div>
                                    : null}
                            </Tab>
                            <Tab eventKey="TERMINAL" title={getTitle('TERMINAL', values.TERMINAL_status, values.TERMINAL_statusName)}>
                                <div id="TERMINAL" className={values.TERMINAL_isNa === 1 ? 'department notapplys' : 'department'}>
                                    <div className="fieldset"
                                        style={
                                            data?.departmentname === 'AOCC' || data?.departmentname === 'TERMINAL' && values?.TERMINAL_status == 3
                                                ? { pointerEvents: 'none' }
                                                : data?.departmentname === 'TERMINAL' ||
                                                    data?.departmentname === 'AOCC' ||
                                                    data?.departmentname === 'HSSE'
                                                    ? { pointerEvents: 'all' }
                                                    : { pointerEvents: 'none' }
                                        }
                                    >
                                        <h1><span>TERMINAL</span>
                                            <div className="chekbox">
                                                <label>Not Applicable
                                                    <input
                                                        type="checkbox"
                                                        className="notapply"
                                                        checked={values.TERMINAL_isNa === 1}
                                                        onChange={(e) => {
                                                            setFieldValue('TERMINAL_isNa', e.target.checked ? 1 : 0);
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        </h1>
                                        {values.TERMINAL_isNa === 1 ? null :
                                            <div className="formsBox">
                                                <Row>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Terminal Supervisor on Duty</label>
                                                            <input
                                                                type="text"
                                                                id="terminalSupervisoronDuty"
                                                                name="terminalSupervisoronDuty"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={values.terminalSupervisoronDuty}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.terminalSupervisoronDuty && touched.terminalSupervisoronDuty && (
                                                                <p className="errormsg">{errors.terminalSupervisoronDuty}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Terminal Evacuation Required?</label>
                                                            <SelectFild
                                                                Firstop='Select Terminal Evacuation Required?'
                                                                selectName="terminalEvacuationRequired"
                                                                options={[
                                                                    { name: 'Yes', id: 'yes' },
                                                                    { name: 'No', id: 'no' },
                                                                ]}
                                                                value={values.terminalEvacuationRequired}
                                                                onChange={(selectedOption) => setFieldValue("terminalEvacuationRequired", selectedOption?.value || "")}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.terminalEvacuationRequired && touched.terminalEvacuationRequired && (
                                                                <p className="errormsg">{errors.terminalEvacuationRequired}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Action Time</label>
                                                            <TimeFild
                                                                value={values.tActionTime}
                                                                onChange={(time) => setFieldValue('tActionTime', time)}
                                                                format="local"
                                                            />
                                                            {errors.tActionTime && touched.tActionTime && (
                                                                <p className="errormsg">{errors.tActionTime}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Passenger Impact Assessment</label>
                                                            <SelectFild
                                                                Firstop="Select Passenger Impact Assessment"
                                                                selectName='passengerImpactAs'
                                                                options={passengerImpactM}
                                                                value={values.passengerImpactAs}
                                                                onChange={(selectedOption) => setFieldValue("passengerImpactAs", selectedOption?.value || "")}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.passengerImpactAs && touched.passengerImpactAs && (
                                                                <p className="errormsg">{errors.passengerImpactAs}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Passenger Impact Sub Assessment</label>
                                                            <div className="chkgroup">
                                                                {(passengerImpactS || []).map((item) => (
                                                                    <div className="chekbox" key={item.id}>
                                                                        <label>
                                                                            {item.name}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={item.id}
                                                                                checked={(values.passengerImpactSubAs || []).includes(item.id)}
                                                                                onChange={(e) => handlePassengerImpChange(item.id, e.target.checked)}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            {errors.passengerImpactSubAs && touched.passengerImpactSubAs && (
                                                                <p className="errormsg">{errors.passengerImpactSubAs}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Crowd Control Actions</label>
                                                            <textarea
                                                                id="crowdControlActions"
                                                                name="crowdControlActions"
                                                                className="form-control"
                                                                value={values.crowdControlActions}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.crowdControlActions && touched.crowdControlActions && (
                                                                <p className="errormsg">{errors.crowdControlActions}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Recommendation By Hod</label>
                                                            <textarea
                                                                id="TERMINAL_recommendationhod"
                                                                name="TERMINAL_recommendationhod"
                                                                className="form-control"
                                                                value={values.TERMINAL_recommendationhod}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                readOnly={
                                                                    (data?.departmentname === 'TERMINAL' && data.is_hod !== 1) ||
                                                                    (data?.departmentname !== 'HSSE' && data?.departmentname !== 'TERMINAL')
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                    {values.TERMINAL_recommendationhod == '' && data?.departmentname === 'HSSE' ?
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Remarks</label>
                                                                <textarea
                                                                    id="TERMINAL_remarks"
                                                                    name="TERMINAL_remarks"
                                                                    className="form-control"
                                                                    value={values.TERMINAL_remarks}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </div>
                                                        </Col>
                                                        : null
                                                    }
                                                </Row>
                                                <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                {Array.isArray(terinalImgs) && (
                                                    <div className='previewsimges'>
                                                        {terinalImgs.map((fileUrl, index) => {
                                                            if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                                                return (
                                                                    <div key={index} className='imageboxs'>
                                                                        <div className='imgs pdfs'>
                                                                            <div>
                                                                                <div className="pdf-icon">
                                                                                    <FaFilePdf size={48} color="#e74c3c" />
                                                                                </div>
                                                                                <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                            return (
                                                                <div key={index} className='imageboxs'>
                                                                    <div className='imgs'>
                                                                        <img src={fileUrl} alt={`Image ${index + 1}`} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {data?.departmentname === 'TERMINAL' || data?.departmentname === 'AOCC' || data?.departmentname === 'HSSE' ?
                                    <div className="button-boxs grid">
                                        <button type="submit" className="btn btn-orange">Submit</button>
                                    </div>
                                    : null}
                            </Tab>
                            <Tab eventKey="ENGINEERING" title={getTitle('ENGINEERING', values.ENGINEERING_status, values.ENGINEERING_statusName)}>
                                <div id="ENGINEERING" className={values.ENGINEERING_isNa === 1 ? 'department notapplys' : 'department'}>
                                    <div className="fieldset"
                                        style={
                                            data?.departmentname === 'AOCC' || data?.departmentname === 'ENGINEERING' && values?.ENGINEERING_status == 3
                                                ? { pointerEvents: 'none' }
                                                : data?.departmentname === 'ENGINEERING' ||
                                                    data?.departmentname === 'AOCC' ||
                                                    data?.departmentname === 'HSSE'
                                                    ? { pointerEvents: 'all' }
                                                    : { pointerEvents: 'none' }
                                        }
                                    >
                                        <h1><span>ENGINEERING</span>
                                            <div className="chekbox">
                                                <label>Not Applicable
                                                    <input
                                                        type="checkbox"
                                                        className="notapply"
                                                        checked={values.ENGINEERING_isNa === 1}
                                                        onChange={(e) => {
                                                            setFieldValue('ENGINEERING_isNa', e.target.checked ? 1 : 0);
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        </h1>
                                        {values.ENGINEERING_isNa === 1 ? null :
                                            <div className="formsBox">
                                                <Row>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Person Name</label>
                                                            <input
                                                                type="text"
                                                                id="ePersonName"
                                                                name="ePersonName"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={values.ePersonName}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.ePersonName && touched.ePersonName && (
                                                                <p className="errormsg">{errors.ePersonName}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Action Time</label>
                                                            <TimeFild
                                                                value={values.eActionTime}
                                                                onChange={(time) => setFieldValue('eActionTime', time)}
                                                                format="local"
                                                            />
                                                            {errors.eActionTime && touched.eActionTime && (
                                                                <p className="errormsg">{errors.eActionTime}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Occurrence Type</label>
                                                            <SelectFild
                                                                Firstop='Select Occurrence Type'
                                                                selectName="eOccurrenceType"
                                                                options={[
                                                                    { name: 'Equipment Failure', id: 'Equipment Failure' },
                                                                    { name: 'Infrastructure Damage', id: 'Infrastructure Damage' },
                                                                    { name: 'Electrical Hazard', id: 'Electrical Hazard' },
                                                                    { name: 'Mechanical Fault', id: 'Mechanical Fault' },
                                                                    { name: 'Other', id: 'Other' },
                                                                ]}
                                                                value={values.eOccurrenceType}
                                                                onChange={(selectedOption) => setFieldValue("eOccurrenceType", selectedOption?.value || "")}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.eOccurrenceType && touched.eOccurrenceType && (
                                                                <p className="errormsg">{errors.eOccurrenceType}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Location</label>
                                                            <SelectFild
                                                                Firstop='Select Location'
                                                                selectName="eLocation"
                                                                options={[
                                                                    { name: 'Airside', id: 'Airside' },
                                                                    { name: 'Terminal', id: 'Terminal' },
                                                                    { name: 'Landside', id: 'Landside' },
                                                                    { name: 'Apron', id: 'Apron' },
                                                                    { name: 'Runway', id: 'Runway' },
                                                                    { name: 'Taxiway', id: 'Taxiway' },
                                                                    { name: 'Ramp', id: 'Ramp' },
                                                                    { name: 'Workshop', id: 'Workshop' },
                                                                    { name: 'Hangar', id: 'Hangar' },
                                                                    { name: 'Cargo Area', id: 'Cargo Area' },
                                                                    { name: 'Baggage Handling Area', id: 'Baggage Handling Area' },
                                                                    { name: 'Passenger Gate / Boarding Gate', id: 'Passenger Gate / Boarding Gate' },
                                                                    { name: 'Security Checkpoint', id: 'Security Checkpoint' },
                                                                    { name: 'Control Tower / Operations Center', id: 'Control Tower / Operations Center' },
                                                                    { name: 'Fuel Farm / Refueling Area', id: 'Fuel Farm / Refueling Area' },
                                                                    { name: 'Fire Station / Emergency Services', id: 'Fire Station / Emergency Services' },
                                                                    { name: 'Car Park / Parking Lot', id: 'Car Park / Parking Lot' },
                                                                    { name: 'Access Road / Perimeter Road', id: 'Access Road / Perimeter Road' },
                                                                    { name: 'Administrative Offices', id: 'Administrative Offices' },
                                                                    { name: 'Retail / Concessions Area', id: 'Retail / Concessions Area' },
                                                                    { name: 'Customs / Immigration', id: 'Customs / Immigration' },
                                                                    { name: 'VIP / Executive Lounge', id: 'VIP / Executive Lounge' },
                                                                    { name: 'Bus / Shuttle Zone', id: 'Bus / Shuttle Zone' },
                                                                    { name: 'Waste Management Area', id: 'Waste Management Area' },
                                                                    { name: 'Other', id: 'Other' },
                                                                ]}
                                                                value={values.eLocation}
                                                                onChange={(selectedOption) => setFieldValue("eLocation", selectedOption?.value || "")}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.eLocation && touched.eLocation && (
                                                                <p className="errormsg">{errors.eLocation}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    {values.eOccurrenceType === 'Other' && (
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Other Occurrence Type</label>
                                                                <textarea
                                                                    id="eOtherOccurrenceType"
                                                                    name="eOtherOccurrenceType"
                                                                    className="form-control"
                                                                    value={values.eOtherOccurrenceType}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                {errors.eOtherOccurrenceType && touched.eOtherOccurrenceType && (
                                                                    <p className="errormsg">{errors.eOtherOccurrenceType}</p>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    )}
                                                    {values.eLocation === 'Other' && (
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Other Location</label>
                                                                <textarea
                                                                    id="eOtherLocation"
                                                                    name="eOtherLocation"
                                                                    className="form-control"
                                                                    value={values.eOtherLocation}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                {errors.eOtherLocation && touched.eOtherLocation && (
                                                                    <p className="errormsg">{errors.eOtherLocation}</p>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    )}
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Supervisor/Manager Notified</label>
                                                            <input
                                                                type="text"
                                                                id="eSupervisorManagerNotified"
                                                                name="eSupervisorManagerNotified"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={values.eSupervisorManagerNotified}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.eSupervisorManagerNotified && touched.eSupervisorManagerNotified && (
                                                                <p className="errormsg">{errors.eSupervisorManagerNotified}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Follow-up Required</label>
                                                            <SelectFild
                                                                Firstop='Select Follow-up Required'
                                                                selectName="eFollowupRequired"
                                                                options={[
                                                                    { name: 'Yes', id: 'yes' },
                                                                    { name: 'No', id: 'no' },
                                                                ]}
                                                                value={values.eFollowupRequired}
                                                                onChange={(selectedOption) => setFieldValue("eFollowupRequired", selectedOption?.value || "")}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.eFollowupRequired && touched.eFollowupRequired && (
                                                                <p className="errormsg">{errors.eFollowupRequired}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Action Taken</label>
                                                            <textarea
                                                                id="eActionTaken"
                                                                name="eActionTaken"
                                                                className="form-control"
                                                                value={values.eActionTaken}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.eActionTaken && touched.eActionTaken && (
                                                                <p className="errormsg">{errors.eActionTaken}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Recommendation By Hod</label>
                                                            <textarea
                                                                id="ENGINEERING_recommendationhod"
                                                                name="ENGINEERING_recommendationhod"
                                                                className="form-control"
                                                                value={values.ENGINEERING_recommendationhod}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                readOnly={
                                                                    (data?.departmentname === 'ENGINEERING' && data.is_hod !== 1) ||
                                                                    (data?.departmentname !== 'HSSE' && data?.departmentname !== 'ENGINEERING')
                                                                }
                                                            // readOnly={data.is_hod === 1 && data?.departmentname === 'ENGINEERING' ? false : true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    {values.ENGINEERING_recommendationhod == '' && data?.departmentname === 'HSSE' ?
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Remarks</label>
                                                                <textarea
                                                                    id="ENGINEERING_remarks"
                                                                    name="ENGINEERING_remarks"
                                                                    className="form-control"
                                                                    value={values.ENGINEERING_remarks}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </div>
                                                        </Col>
                                                        : null
                                                    }
                                                </Row>
                                                <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                {Array.isArray(engineeringImgs) && (
                                                    <div className='previewsimges'>
                                                        {engineeringImgs.map((fileUrl, index) => {
                                                            if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                                                return (
                                                                    <div key={index} className='imageboxs'>
                                                                        <div className='imgs pdfs'>
                                                                            <div>
                                                                                <div className="pdf-icon">
                                                                                    <FaFilePdf size={48} color="#e74c3c" />
                                                                                </div>
                                                                                <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                            return (
                                                                <div key={index} className='imageboxs'>
                                                                    <div className='imgs'>
                                                                        <img src={fileUrl} alt={`Image ${index + 1}`} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {data?.departmentname === 'ENGINEERING' || data?.departmentname === 'AOCC' || data?.departmentname === 'HSSE' ?
                                    <div className="button-boxs grid">
                                        <button type="submit" className="btn btn-orange">Submit</button>
                                    </div>
                                    : null}
                            </Tab>
                            <Tab eventKey="FIRE" title={getTitle('FIRE', values.FIRE_status, values.FIRE_statusName)}>
                                <div id="FIRE" className={values.FIRE_isNa === 1 ? 'department notapplys' : 'department'}>
                                    <div
                                        className="fieldset"
                                        style={
                                            data?.departmentname === 'AOCC' || data?.departmentname === 'FIRE' && values?.FIRE_status == 3
                                                ? { pointerEvents: 'none' }
                                                : data?.departmentname === 'FIRE' ||
                                                    data?.departmentname === 'AOCC' ||
                                                    data?.departmentname === 'HSSE'
                                                    ? { pointerEvents: 'all' }
                                                    : { pointerEvents: 'none' }
                                        }
                                    >
                                        <h1><span>FIRE</span>
                                            <div className="chekbox">
                                                <label>Not Applicable
                                                    <input
                                                        type="checkbox"
                                                        className="notapply"
                                                        checked={values.FIRE_isNa === 1}
                                                        onChange={(e) => {
                                                            setFieldValue('FIRE_isNa', e.target.checked ? 1 : 0);
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        </h1>
                                        {values.FIRE_isNa === 1 ? null :
                                            <div className="formsBox">
                                                <Row>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Fire Commander Name</label>
                                                            <input
                                                                type="text"
                                                                id="fireCommanderName"
                                                                name="fireCommanderName"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={values.fireCommanderName}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.fireCommanderName && touched.fireCommanderName && (
                                                                <p className="errormsg">{errors.fireCommanderName}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Fire Category Incident Code</label>
                                                            <SelectFild
                                                                Firstop='Select Fire Category Incident Code'
                                                                selectName="fireCategoryIncidentCode"
                                                                options={[
                                                                    { name: 'CAT 1', id: '1' },
                                                                    { name: 'CAT 2', id: '2' },
                                                                    { name: 'CAT 3', id: '3' },
                                                                    { name: 'CAT 4', id: '4' },
                                                                    { name: 'CAT 5', id: '5' },
                                                                    { name: 'CAT 6', id: '6' },
                                                                    { name: 'CAT 7', id: '7' },
                                                                    { name: 'CAT 8', id: '8' },
                                                                    { name: 'CAT 9', id: '9' },
                                                                    { name: 'CAT 10', id: '10' },
                                                                ]}
                                                                value={values.fireCategoryIncidentCode}
                                                                onChange={(selectedOption) => setFieldValue("fireCategoryIncidentCode", selectedOption?.value || "")}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.fireCategoryIncidentCode && touched.fireCategoryIncidentCode && (
                                                                <p className="errormsg">{errors.fireCategoryIncidentCode}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Unit Dispatched</label>
                                                            <input
                                                                type="text"
                                                                id="unitDispatched"
                                                                name="unitDispatched"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={values.unitDispatched}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.unitDispatched && touched.unitDispatched && (
                                                                <p className="errormsg">{errors.unitDispatched}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Unit Arrival Time</label>
                                                            <TimeFild
                                                                value={values.unitArrivalTime}
                                                                onChange={(time) => setFieldValue('unitArrivalTime', time)}
                                                                format="local"
                                                            />
                                                            {errors.unitArrivalTime && touched.unitArrivalTime && (
                                                                <p className="errormsg">{errors.unitArrivalTime}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Action Taken</label>
                                                            <textarea
                                                                id="fActionTaken"
                                                                name="fActionTaken"
                                                                className="form-control"
                                                                value={values.fActionTaken}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.fActionTaken && touched.fActionTaken && (
                                                                <p className="errormsg">{errors.fActionTaken}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Recommendation By Hod</label>
                                                            <textarea
                                                                id="FIRE_recommendationhod"
                                                                name="FIRE_recommendationhod"
                                                                className="form-control"
                                                                value={values.FIRE_recommendationhod}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                readOnly={
                                                                    (data?.departmentname === 'FIRE' && data.is_hod !== 1) ||
                                                                    (data?.departmentname !== 'HSSE' && data?.departmentname !== 'FIRE')
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                    {values.FIRE_recommendationhod == '' && data?.departmentname === 'HSSE' ?
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Remarks</label>
                                                                <textarea
                                                                    id="FIRE_remarks"
                                                                    name="FIRE_remarks"
                                                                    className="form-control"
                                                                    value={values.FIRE_remarks}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </div>
                                                        </Col>
                                                        : null
                                                    }
                                                </Row>
                                                <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                {Array.isArray(fireImgs) && (
                                                    <div className='previewsimges'>
                                                        {fireImgs.map((fileUrl, index) => {
                                                            if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                                                return (
                                                                    <div key={index} className='imageboxs'>
                                                                        <div className='imgs pdfs'>
                                                                            <div>
                                                                                <div className="pdf-icon">
                                                                                    <FaFilePdf size={48} color="#e74c3c" />
                                                                                </div>
                                                                                <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                            return (
                                                                <div key={index} className='imageboxs'>
                                                                    <div className='imgs'>
                                                                        <img src={fileUrl} alt={`Image ${index + 1}`} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {data?.departmentname === 'FIRE' || data?.departmentname === 'AOCC' || data?.departmentname === 'HSSE' ?
                                    <div className="button-boxs grid">
                                        <button type="submit" className="btn btn-orange">Submit</button>
                                    </div>
                                    : null}
                            </Tab>
                            <Tab eventKey="OTHERS" title={getTitle('OTHERS', values.OTHERS_status, values.OTHERS_statusName)}>
                                <div id="OTHERS" className={values.OTHERS_isNa === 1 ? 'department notapplys' : 'department'}>
                                    <div
                                        className="fieldset"
                                        style={
                                            data?.departmentname === 'AOCC' || data?.departmentname === 'OTHERS' && values?.OTHERS_status == 3
                                                ? { pointerEvents: 'none' }
                                                : data?.departmentname === 'OTHERS' ||
                                                    data?.departmentname === 'AOCC' ||
                                                    data?.departmentname === 'HSSE'
                                                    ? { pointerEvents: 'all' }
                                                    : { pointerEvents: 'none' }
                                        }
                                    >
                                        <h1><span>OTHERS</span>
                                            <div className="chekbox">
                                                <label>Not Applicable
                                                    <input
                                                        type="checkbox"
                                                        className="notapply"
                                                        checked={values.OTHERS_isNa === 1}
                                                        onChange={(e) => {
                                                            setFieldValue('OTHERS_isNa', e.target.checked ? 1 : 0);
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        </h1>
                                        {values.OTHERS_isNa === 1 ? null :
                                            <div className="formsBox">
                                                <Row>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Person name</label>
                                                            <input
                                                                type="text"
                                                                id="othersPersonname"
                                                                name="othersPersonname"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={values.othersPersonname}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.othersPersonname && touched.othersPersonname && (
                                                                <p className="errormsg">{errors.othersPersonname}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Specify Department</label>
                                                            <input
                                                                type="text"
                                                                id="othersSpecifyDepartment"
                                                                name="othersSpecifyDepartment"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={values.othersSpecifyDepartment}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.othersSpecifyDepartment && touched.othersSpecifyDepartment && (
                                                                <p className="errormsg">{errors.othersSpecifyDepartment}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Action Time</label>
                                                            <TimeFild
                                                                value={values.othersActionTime}
                                                                onChange={(time) => setFieldValue('othersActionTime', time)}
                                                                format="local"
                                                            />
                                                            {errors.othersActionTime && touched.othersActionTime && (
                                                                <p className="errormsg">{errors.othersActionTime}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Occurrence Type</label>
                                                            <SelectFild
                                                                Firstop='Select Occurrence Type'
                                                                selectName="othersOccurrenceType"
                                                                options={[
                                                                    { name: 'Personal Injury', id: 'Personal Injury' },
                                                                    { name: 'Unsafe Act', id: 'Unsafe Act' },
                                                                    { name: 'Unsafe Condition', id: 'Unsafe Condition' },
                                                                    { name: 'Environmental Hazard', id: 'Environmental Hazard' },
                                                                    { name: 'Other', id: 'Other' },
                                                                ]}
                                                                value={values.othersOccurrenceType}
                                                                onChange={(selectedOption) => setFieldValue("othersOccurrenceType", selectedOption?.value || "")}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.othersOccurrenceType && touched.othersOccurrenceType && (
                                                                <p className="errormsg">{errors.othersOccurrenceType}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    {values.othersOccurrenceType == 'Other' && <>
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Other Details</label>
                                                                <textarea
                                                                    id="othersDetails"
                                                                    name="othersDetails"
                                                                    className="form-control"
                                                                    value={values.othersDetails}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                {errors.othersDetails && touched.othersDetails && (
                                                                    <p className="errormsg">{errors.othersDetails}</p>
                                                                )}
                                                            </div>
                                                        </Col>
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Other Location</label>
                                                                <textarea
                                                                    id="othersLocation"
                                                                    name="othersLocation"
                                                                    className="form-control"
                                                                    value={values.othersLocation}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                {errors.othersLocation && touched.othersLocation && (
                                                                    <p className="errormsg">{errors.othersLocation}</p>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </>}
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Action Taken</label>
                                                            <textarea
                                                                id="othersActionTaken"
                                                                name="othersActionTaken"
                                                                className="form-control"
                                                                value={values.othersActionTaken}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.othersActionTaken && touched.othersActionTaken && (
                                                                <p className="errormsg">{errors.othersActionTaken}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Recommendation By Hod</label>
                                                            <textarea
                                                                id="OTHERS_recommendationhod"
                                                                name="OTHERS_recommendationhod"
                                                                className="form-control"
                                                                value={values.OTHERS_recommendationhod}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                readOnly={
                                                                    (data?.departmentname === 'OTHERS' && data.is_hod !== 1) ||
                                                                    (data?.departmentname !== 'HSSE' && data?.departmentname !== 'OTHERS')
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                    {values.OTHERS_recommendationhod == '' && data?.departmentname === 'HSSE' ?
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Remarks</label>
                                                                <textarea
                                                                    id="OTHERS_remarks"
                                                                    name="OTHERS_remarks"
                                                                    className="form-control"
                                                                    value={values.OTHERS_remarks}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </div>
                                                        </Col>
                                                        : null
                                                    }
                                                </Row>
                                                <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                {Array.isArray(otherImgs) && (
                                                    <div className='previewsimges'>
                                                        {otherImgs.map((fileUrl, index) => {
                                                            if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                                                return (
                                                                    <div key={index} className='imageboxs'>
                                                                        <div className='imgs pdfs'>
                                                                            <div>
                                                                                <div className="pdf-icon">
                                                                                    <FaFilePdf size={48} color="#e74c3c" />
                                                                                </div>
                                                                                <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                            return (
                                                                <div key={index} className='imageboxs'>
                                                                    <div className='imgs'>
                                                                        <img src={fileUrl} alt={`Image ${index + 1}`} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {data?.departmentname === 'OTHERS' || data?.departmentname === 'AOCC' || data?.departmentname === 'HSSE' ?
                                    <div className="button-boxs grid">
                                        <button type="submit" className="btn btn-orange">Submit</button>
                                    </div>
                                    : null}
                            </Tab>
                            <Tab eventKey="AIRLINE" title={getTitle('AIRLINE', values.AIRLINE_status, values.AIRLINE_statusName)}>
                                <div id="AIRLINE" className={values.AIRLINE_isNa === 1 ? 'department notapplys' : 'department'}>
                                    <div
                                        className="fieldset"
                                        style={
                                            data?.departmentname === 'AOCC' || data?.departmentname === 'AIRLINE' && values?.OTHERS_status == 3
                                                ? { pointerEvents: 'none' }
                                                : data?.departmentname === 'AIRLINE' ||
                                                    data?.departmentname === 'AOCC' ||
                                                    data?.departmentname === 'HSSE'
                                                    ? { pointerEvents: 'all' }
                                                    : { pointerEvents: 'none' }
                                        }
                                    >
                                        <h1><span>AIRLINE</span>
                                            <div className="chekbox">
                                                <label>Not Applicable
                                                    <input
                                                        type="checkbox"
                                                        className="notapply"
                                                        checked={values.AIRLINE_isNa === 1}
                                                        onChange={(e) => {
                                                            setFieldValue('AIRLINE_isNa', e.target.checked ? 1 : 0);
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        </h1>
                                        {values.AIRLINE_isNa === 1 ? null :
                                            <div className="formsBox">
                                                <Row>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Person name</label>
                                                            <input
                                                                type="text"
                                                                id="airlinePersonName"
                                                                name="airlinePersonName"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={values.airlinePersonName}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.airlinePersonName && touched.airlinePersonName && (
                                                                <p className="errormsg">{errors.airlinePersonName}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Aircraft Registration</label>
                                                            <div className='selectwith_input'>
                                                                <div className='selects'>
                                                                    <SelectFild
                                                                        Firstop="Select"
                                                                        selectName='airlineCode'
                                                                        options={aircraftRegistration}
                                                                        value={values.airlineCode}
                                                                        onChange={(selectedOption) => setFieldValue("airlineCode", selectedOption?.value || "")}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="airlineFlightNumber"
                                                                    value={values.airlineFlightNumber}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </div>
                                                            {errors.airlineCode && touched.airlineCode && (
                                                                <p className="errormsg">{errors.airlineCode}</p>
                                                            )}
                                                            {errors.airlineFlightNumber && touched.airlineFlightNumber && (
                                                                <p className="errormsg">{errors.airlineFlightNumber}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Aircraft Type</label>
                                                            <SelectFild
                                                                Firstop="Select Aircraft Type"
                                                                selectName='airlineAircraftType'
                                                                options={aircraftTypes}
                                                                value={values.airlineAircraftType}
                                                                onChange={(selectedOption) => setFieldValue("airlineAircraftType", selectedOption?.value || "")}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.airlineAircraftType && touched.airlineAircraftType && (
                                                                <p className="errormsg">{errors.airlineAircraftType}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Delay Reason</label>
                                                            <input
                                                                type="text"
                                                                id="airlineDelayReason"
                                                                name="airlineDelayReason"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={values.airlineDelayReason}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.airlineDelayReason && touched.airlineDelayReason && (
                                                                <p className="errormsg">{errors.airlineDelayReason}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Arrival Time</label>
                                                            <TimeFild
                                                                value={values.airlineArrivalTime}
                                                                onChange={(time) => setFieldValue('airlineArrivalTime', time)}
                                                                format="local"
                                                            />
                                                            {errors.airlineArrivalTime && touched.airlineArrivalTime && (
                                                                <p className="errormsg">{errors.airlineArrivalTime}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Departure Time</label>
                                                            <TimeFild
                                                                value={values.airlineDepartureTime}
                                                                onChange={(time) => setFieldValue('airlineDepartureTime', time)}
                                                                format="local"
                                                            />
                                                            {errors.airlineDepartureTime && touched.airlineDepartureTime && (
                                                                <p className="errormsg">{errors.airlineDepartureTime}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Gate Number</label>
                                                            <input
                                                                type="text"
                                                                id="airlineGateNumber"
                                                                name="airlineGateNumber"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                min="0"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                value={values.airlineGateNumber}
                                                                onChange={(e) => {
                                                                    const onlyNums = e.target.value.replace(/\D/g, ''); // Remove non-digits
                                                                    const syntheticEvent = {
                                                                        target: {
                                                                            name: 'airlineGateNumber',
                                                                            value: onlyNums,
                                                                        },
                                                                    };
                                                                    handleChange(syntheticEvent);
                                                                }}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.airlineGateNumber && touched.airlineGateNumber && (
                                                                <p className="errormsg">{errors.airlineGateNumber}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Number of Passengers</label>
                                                            <input
                                                                type="text"
                                                                id="airlineNumberofPassengers"
                                                                name="airlineNumberofPassengers"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                min="0"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                value={values.airlineNumberofPassengers}
                                                                onChange={(e) => {
                                                                    const onlyNums = e.target.value.replace(/\D/g, ''); // Remove non-digits
                                                                    const syntheticEvent = {
                                                                        target: {
                                                                            name: 'airlineNumberofPassengers',
                                                                            value: onlyNums,
                                                                        },
                                                                    };
                                                                    handleChange(syntheticEvent);
                                                                }}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.airlineNumberofPassengers && touched.airlineNumberofPassengers && (
                                                                <p className="errormsg">{errors.airlineNumberofPassengers}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <label>Recommendation By Hod</label>
                                                            <textarea
                                                                id="AIRLINE_recommendationhod"
                                                                name="AIRLINE_recommendationhod"
                                                                className="form-control"
                                                                value={values.AIRLINE_recommendationhod}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                readOnly={
                                                                    (data?.departmentname === 'AIRLINE' && data.is_hod !== 1) ||
                                                                    (data?.departmentname !== 'HSSE' && data?.departmentname !== 'AIRLINE')
                                                                }
                                                            />
                                                        </div>
                                                    </Col>
                                                    {values.AIRLINE_recommendationhod == '' && data?.departmentname === 'HSSE' ?
                                                        <Col md={6}>
                                                            <div className="form-group">
                                                                <label>Remarks</label>
                                                                <textarea
                                                                    id="AIRLINE_remarks"
                                                                    name="AIRLINE_remarks"
                                                                    className="form-control"
                                                                    value={values.AIRLINE_remarks}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </div>
                                                        </Col>
                                                        : null
                                                    }
                                                </Row>
                                                <UploadWithSignature onFilesChange={setUploadedFiles} />
                                                {Array.isArray(AirlineImgs) && (
                                                    <div className='previewsimges'>
                                                        {AirlineImgs.map((fileUrl, index) => {
                                                            if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                                                return (
                                                                    <div key={index} className='imageboxs'>
                                                                        <div className='imgs pdfs'>
                                                                            <div>
                                                                                <div className="pdf-icon">
                                                                                    <FaFilePdf size={48} color="#e74c3c" />
                                                                                </div>
                                                                                <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                            return (
                                                                <div key={index} className='imageboxs'>
                                                                    <div className='imgs'>
                                                                        <img src={fileUrl} alt={`Image ${index + 1}`} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {data?.departmentname === 'OTHERS' || data?.departmentname === 'AOCC' || data?.departmentname === 'HSSE' ?
                                    <div className="button-boxs grid">
                                        <button type="submit" className="btn btn-orange">Submit</button>
                                    </div>
                                    : null}
                            </Tab>
                        </Tabs>
                    </form>
                </div>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    );
});

export default ActionTakenByDepartment